import type { DialogProps } from '@radix-ui/react-dialog';
import { Root, Trigger, Portal, Overlay, Content, Title, Description, Close } from '@radix-ui/react-dialog';
import { Button, Anchor, ClickableIcon } from '@zenid/web';
import { dialog } from '../../../../../../styled-system/recipes';
import { css } from '../../../../../../styled-system/css';

export function EmailResendDialog({
  email,
  onClickOk,
  ...props
}: Omit<DialogProps, 'children'> & { email: string; onClickOk: () => void }) {
  const {
    overlay: overlayStyle,
    content: contentStyle,
    banner: bannerStyle,
    titleAndDescriptionWrapper: titleAndDescriptionWrapperStyle,
    title: titleStyle,
    description: descriptionStyle,
    closeButton: closeButtonStyle,
    actionButtons: actionButtonsStyle,
  } = dialog();
  return (
    <Root {...props}>
      {/* https://github.com/radix-ui/primitives/discussions/1234#discussioncomment-8882846 */}
      {/* radix-uiはアクセシビリティの制約が強く、ユーザーによる操作以外でダイアログを開くことを制限している
      APIの成功可否で当ダイアログの開閉を行えるようにしたいため、推奨されていない方法ではあるがプログラムから呼び出せるように回避策を仕込む */}
      <Trigger className={css({ display: 'none' })} />
      <Portal>
        <Overlay className={overlayStyle} />
        <Content className={contentStyle}>
          <div className={bannerStyle}>
            <img src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/email.png`} alt="" />
          </div>
          <div className={titleAndDescriptionWrapperStyle}>
            <Title className={titleStyle}>メールを再送しました</Title>
            <Description className={descriptionStyle}>
              {`${email} 宛に認証確認メールを再送しました。`}
              <br />
              メール記載のURLからメールアドレス認証を完了してください。
              <br />
              <br />
              ※メールが見当たらない場合は、迷惑メールフォルダやドメイン受信設定をご確認ください。
              <br />
              <Anchor
                href="https://help.zenid.jp/hc/ja/articles/38655145589657"
                target="_blank"
                rel="noopener noreferrer"
              >
                よくある質問はこちら
              </Anchor>
            </Description>
          </div>
          <div className={actionButtonsStyle}>
            <Button width={200} color="secondary" size="m" onClick={onClickOk}>
              OK
            </Button>
          </div>
          <Close asChild>
            <ClickableIcon
              className={closeButtonStyle}
              name="close"
              color="colors.text.main"
              size="l"
              aria-label="閉じるボタン"
            />
          </Close>
        </Content>
      </Portal>
    </Root>
  );
}
